import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';

import { API } from '../../config';

const AdminOrders = () => {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState('all');
  const t = () => localStorage.getItem('tp_admin_token');
  const load = async () => {
    const r = await axios.get(`${API}/admin/orders`, { headers: { Authorization: `Bearer ${t()}` } });
    setList(r.data);
  };
  useEffect(() => { load(); }, []);
  const update = async (id, status) => {
    await axios.patch(`${API}/admin/orders/${id}`, { status }, { headers: { Authorization: `Bearer ${t()}` } });
    load();
  };
  const filtered = filter === 'all' ? list : list.filter(o => o.status === filter);

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h1 className="text-2xl font-bold text-[#0B2E5C]">All Orders</h1>
          <p className="text-sm text-gray-500">{filtered.length} orders</p>
        </div>
        <Select value={filter} onValueChange={setFilter}>
          <SelectTrigger className="w-40"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="placed">Placed</SelectItem>
            <SelectItem value="preparing">Preparing</SelectItem>
            <SelectItem value="out_for_delivery">Out for delivery</SelectItem>
            <SelectItem value="delivered">Delivered</SelectItem>
            <SelectItem value="cancelled">Cancelled</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="bg-white rounded-xl border border-gray-100 card-shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
            <tr><th className="text-left py-3 px-4">Order ID</th><th className="text-left py-3 px-4">Restaurant</th><th className="text-left py-3 px-4">PNR / Train</th><th className="text-left py-3 px-4">Items</th><th className="text-left py-3 px-4">Total</th><th className="text-left py-3 px-4">Status</th></tr>
          </thead>
          <tbody>
            {filtered.map(o => (
              <tr key={o.id} className="border-t">
                <td className="py-3 px-4 font-mono text-xs">{o.id.slice(0,8).toUpperCase()}</td>
                <td className="py-3 px-4">{o.restaurant_name}</td>
                <td className="py-3 px-4 text-xs">{o.pnr} • {o.train_number}</td>
                <td className="py-3 px-4 text-xs text-gray-500">{o.items?.reduce((s,i)=>s+i.qty,0)} items</td>
                <td className="py-3 px-4 font-semibold">₹{o.total}</td>
                <td className="py-3 px-4">
                  <Select value={o.status} onValueChange={v=>update(o.id, v)}>
                    <SelectTrigger className="h-8 text-xs w-36"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      {['placed','preparing','out_for_delivery','delivered','cancelled'].map(s => <SelectItem key={s} value={s}>{s.replace(/_/g,' ')}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && <div className="text-center py-10 text-gray-400">No orders yet</div>}
      </div>
    </div>
  );
};

export default AdminOrders;
